import APIS from "../../constant/Endpoint";
import useGetHook from "../../hooks/useUserServiceGetHook";
import ProfileTab from "./ProfileTab";
// @ts-ignore
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import SettingsTabs from "./SettingsTabs";
import SignatureSettings from "./SignatureSettings";

const Settings = ({}) => {
  const [activeTab, setActiveTab] = useState("profile");

  const { data } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.EMAIL}profile/`,
    params: {},
  });

  return (
    <div className={tw`flex flex-col bg-gray-50`}>
      <SettingsTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className={tw`flex-1 overflow-auto`}>
        {activeTab === "profile" ? (
          <ProfileTab data={data} />
        ) : activeTab === "signature" ? (
          <div className={tw`p-8`}>
            <SignatureSettings 
            username={data?.username} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Settings;
